import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { BoxContainer } from '../layouts/Theme';
import { useSettings } from '../context/SettingsContext';
import Select from './Select';
export default function Shop(props) {
    const { orientation, hasGroupedShop } = useSettings();
    return (_jsx(BoxContainer, { orientation: orientation, sx: Object.assign({ paddingBottom: 0 }, (hasGroupedShop && {
            padding: 0
        })), children: _jsx(Select, {}) }));
}
